/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TelescopeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Journal des requetes
     * Requetes, exceptions, taches... enregistrees par l'API, filtrables par `type`, entreprise (`company_id`), classe de statut HTTP (`status_code` : `2xx`...`5xx`), periode et texte libre. `per_page` entre 10 et 100.
     * @param type
     * @param companyId
     * @param statusCode
     * @param dateFrom
     * @param dateTo
     * @param search
     * @param perPage
     * @returns string
     * @throws ApiError
     */
    public telescopeIndex(
        type?: string | null,
        companyId?: number | null,
        statusCode?: '2xx' | '3xx' | '4xx' | '5xx',
        dateFrom?: string | null,
        dateTo?: string | null,
        search?: string | null,
        perPage?: number | null,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/telescope/entries',
            query: {
                'type': type,
                'company_id': companyId,
                'status_code': statusCode,
                'date_from': dateFrom,
                'date_to': dateTo,
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Purger les entrees Telescope
     * Supprime les entrees, optionnellement seulement celles anterieures a `before` et/ou d'un `type` donne. Irreversible.
     * @param before
     * @param type
     * @returns any
     * @throws ApiError
     */
    public telescopeClear(
        before?: string | null,
        type?: string | null,
    ): CancelablePromise<{
        deleted: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/telescope/entries',
            query: {
                'before': before,
                'type': type,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'une entree Telescope
     * L'entree complete (`content`) pour son `uuid` : requete, reponse, exception et details associes.
     * @param uuid
     * @returns any
     * @throws ApiError
     */
    public telescopeShow(
        uuid: string,
    ): CancelablePromise<{
        uuid: string;
        batch_id: string;
        type: string;
        created_at: string;
        tags: string;
        company_id: number;
        company_name: string;
        content: string;
        batch_entries: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/telescope/entries/{uuid}',
            path: {
                'uuid': uuid,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Types d'entrees du journal
     * Reponse : `[{ type, count }]`, du plus frequent au moins frequent.
     * @returns string
     * @throws ApiError
     */
    public telescopeTypes(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/telescope/types',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
